import { useMemo, useCallback } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import esTranslations from '../locales/es.json';
import enTranslations from '../locales/en.json';

const translations = {
  es: esTranslations,
  en: enTranslations,
};

export const useTranslation = () => {
  const { language } = useLanguage();

  const t = useCallback((key, params = {}) => {
    const keys = key.split('.');
    let value = translations[language];

    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        // Fallback al español si no existe la traducción
        value = translations.es;
        for (const fallbackKey of keys) {
          if (value && value[fallbackKey]) {
            value = value[fallbackKey];
          } else {
            return key; // Retornar la clave si no se encuentra
          }
        }
        break;
      }
    }

    // Reemplazar parámetros si existen
    if (typeof value === 'string' && Object.keys(params).length > 0) {
      return Object.keys(params).reduce(
        (str, param) => str.replace(`{{${param}}}`, params[param]),
        value
      );
    }

    return value || key;
  }, [language]);

  return { t, language };
};

